import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBranchApi, server } from "../../../Service/api/ApiUrls";
import axios from '../../../Service/axios'

export const GetBranchList = createAsyncThunk(
    `branchlist`,
    async () => {
      const res = server.get(getBranchApi);
      return res;
    }
  );